/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * A single action cell in the permission grid
 */
export type PermissionGridActionCellRecordItem = {
    /**
     * Permission action key
     */
    actionKey?: PermissionGridActionCellRecordItem.actionKey;
    decision?: PermissionGridActionCellRecordItem.decision;
    sourceType?: PermissionGridActionCellRecordItem.sourceType;
    /**
     * role:xyz or user:4
     */
    sourceKey?: string | null;
    roleAssignment?: PermissionGridActionCellRecordItem.roleAssignment | null;
    userAssignment?: PermissionGridActionCellRecordItem.userAssignment | null;
}

export namespace PermissionGridActionCellRecordItem {

    /**
     * Permission action key
     */
    export enum actionKey {
        U_READ = 'uRead',
        U_CREATE = 'uCreate',
        U_UPDATE = 'uUpdate',
        U_DELETE = 'uDelete',
        U_EXECUTE = 'uExecute',
    }

    export enum decision {
        ALLOW = 'allow',
        DENY = 'deny',
        NONE = 'none',
    }

    export enum sourceType {
        ROLE = 'role',
        USER = 'user',
        NONE = 'none',
    }

    export enum roleAssignment {
        DIRECT = 'direct',
        INHERITED = 'inherited',
    }

    export enum userAssignment {
        DIRECT = 'direct',
    }


}
